import { all, select, takeEvery, put, call } from 'redux-saga/effects';

import { putAndWait } from 'modules/app/sagas';
import { simpleRequestsLoader } from 'modules/app/utils';
import { createBulkFileSuccess, importCampaignFilesBulkFilters } from 'modules/campaignFiles/actions/bulk';
import { fetchCampaignFiles } from 'modules/campaignFiles/actions/core';
import * as types from 'modules/campaignFiles/actionTypes';
import { getFilters } from 'modules/campaignFiles/selectors';
import { getBulkCampaignFilesParams } from 'modules/campaignFiles/selectors/bulkSelectors';
import { BULK_CREATION_MODAL_SOURCE } from 'modules/campaigns/constants';
import { getSelectedCampaignId } from 'modules/campaigns/selectors/details';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.CREATE_BULK_FILES]: {
    callbacks: {
      success: (_, meta, parentAction) => createBulkFileSuccess(parentAction.payload.campaignId, meta)
    },
    notifications: {
      success: {
        id: 'page.campaigns.createBulkFiles.success',
        defaultMessage: 'The bulk creation has started.',
      },
      failure: {
        id: 'page.campaigns.createBulkFiles.failure',
        defaultMessage: 'An error occurred while starting the bulk creation.',
      },
    },
  },
};

function* refreshCampaignFiles() {
  const campaignId = yield select(getSelectedCampaignId);
  const params = yield select(getBulkCampaignFilesParams);

  yield putAndWait(
    fetchCampaignFiles(campaignId, params, {
      source: BULK_CREATION_MODAL_SOURCE,
    })
  );
}

function* openCreationModalWorker() {
  const filters = yield select(getFilters);
  yield put(importCampaignFilesBulkFilters(filters));
  yield call(refreshCampaignFiles);
}

const REFRESH_TYPES = [
  types.SET_CAMPAIGN_FILES_BULK_FILTER,
  types.REMOVE_CAMPAIGN_FILES_BULK_FILTER,
  types.CLEAR_CAMPAIGN_FILES_BULK_FILTER,
];

export default function* campaignFileBuckSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield takeEvery(types.OPEN_CREATION_MODAL, openCreationModalWorker);
  yield takeEvery(REFRESH_TYPES, refreshCampaignFiles);
}
